import { authAxios, createAxiosInstance } from 'common/utils/axios'

import { ADDRESS_ENDPOINTS, ADDRESS_SERVICE_URL } from 'common/constants/apiUrls'

const {
  CREATE_OR_UPDATE_ADDRESS,
  LINK_ADDRESS,
  DELETE_ADDRESS,
  GET_ADDRESSES,
  GET_ADDRESS_DETAILS,
  GET_ADDRESS_HISTORY,
  POST_ADDRESS_REPORT,
  GET_ADDRESS_VERIFICATION,
  GET_ADDRESS_CHAIN_RECOMMENDATION,
  GET_ADDRESS_ACCOUNT_SUMMARY,
  GET_ADDRESS_CHAINS,
  UPDATE_ADDRESS_HOSTED,
} = ADDRESS_ENDPOINTS

export const authAxiosLocalServer = createAxiosInstance(ADDRESS_SERVICE_URL)

const handler = authAxios

export const CreateOrUpdateAddress = async ({
  address,
  chain,
  type,
  provider_id,
  name_first,
  name_last,
  is_self_hosted,
  scan_for_risk,
  link_id,
  link_type,
}) => {
  const response = await handler.post(CREATE_OR_UPDATE_ADDRESS, {
    address,
    chain,
    type,
    provider_id,
    name_first,
    name_last,
    is_self_hosted,
    scan_for_risk: provider_id ? true : scan_for_risk || false,
    link_id,
    link_type,
  })

  const { data } = response.data

  return data
}
export const LinkAddress = async ({ link_id, link_type, address_id }) => {
  const response = await handler.patch(`${LINK_ADDRESS}/${address_id}/link`, {
    link_id,
    link_type,
  })

  const { data } = response.data

  return data
}
export const DeleteAddress = async ({ address_id }) => {
  const response = await handler.patch(`${DELETE_ADDRESS}/${address_id}`)

  const { data } = response.data

  return data
}

export const UpdateAddressHosted = async ({ address_id, is_self_hosted }) => {
  const response = await handler.patch(`${UPDATE_ADDRESS_HOSTED}/${address_id}`, { is_self_hosted })

  const { data } = response.data

  return data
}

export const GetAddresses = async ({ start_range, end_range, page, size, sort, link_id }) => {
  const params = {
    start_range: start_range && start_range,
    end_range: end_range && end_range,
    start_range_create: start_range && start_range,
    end_range_create: end_range && end_range,
    page: page && page,
    size: size && size,
    sort: sort && sort,
    link_id: link_id && link_id,
  }
  const response = await handler.get(GET_ADDRESSES, { params })

  const { data } = response.data

  return data
}
export const GetAddressDetails = async ({ address_id, start_range, end_range, page, size, sort }) => {
  const response = await handler.get(`${GET_ADDRESS_DETAILS}/${address_id}`, {
    params: {
      start_range: start_range && start_range,
      end_range: end_range && end_range,
      page: page && page,
      size: size && size,
      sort: sort && sort,
    },
  })

  const { data } = response.data

  return data
}
export const GetAddressHistory = async ({ address_id, start_range, end_range, page, size, sort }) => {
  const response = await handler.get(`${GET_ADDRESS_HISTORY}/${address_id}/history`, {
    params: {
      start_range: start_range && start_range,
      end_range: end_range && end_range,
      page: page && page,
      size: size && size,
      sort: sort && sort,
    },
  })

  const { data } = response.data

  return data
}
// !UNSURE IF THIS IS RIGHT
export const PostAddressReport = async ({ address_id, sections, start_range, end_range }) => {
  const response = await handler.post(
    `${POST_ADDRESS_REPORT}/${address_id}/reports?sections=${sections.join(
      ','
    )}&start_range=${start_range}&end_range=${end_range}`
  )

  const { data } = response.data

  return data
}

export const GetAddressVerification = async ({ address, chain }) => {
  const response = await handler.get(`${GET_ADDRESS_VERIFICATION}/${address}/chains/${chain}`)

  const { data } = response.data

  return data
}

export const GetAddressChainRecommendation = async ({ address }) => {
  const response = await handler.get(`${GET_ADDRESS_CHAIN_RECOMMENDATION}/${address}/chain_discovery`)

  const { data } = response.data

  return data
}

export const GetAddressAccountSummary = async ({ account_id, identified }) => {
  const response = await handler.get(GET_ADDRESS_ACCOUNT_SUMMARY, {
    params: {
      account_id,
      identified,
    },
  })
  const { data } = response.data
  return data
}

export const GetAddressChains = async (props) => {
  const params = {}
  if (props?.provider_name) {
    params.provider_name = props?.provider_name
  }
  const response = await handler.get(GET_ADDRESS_CHAINS, { params })

  const { data } = response.data

  return data
}
